import { hoursToMilliseconds, minutesToMilliseconds, secondsToMilliseconds } from 'date-fns';
import { AllAvailableDrivers } from 'src/shared/enums';

import { MillisecondsSchema } from './shared/types';

import type { APIv1RestaurantAdmin } from 'src/shared-interface/ApiRestaurantAdminInterface';
import type { UseMutateAsyncFunction } from '@tanstack/react-query';
import type { imageType } from './zodSchemas/restaurantSchema';
import type { Milliseconds, Uuid } from './shared/types';

export function toMs({
    milliseconds = 0,
    seconds = 0,
    minutes = 0,
    hours = 0,
    days = 0,
}: {
    milliseconds?: number;
    seconds?: number;
    minutes?: number;
    hours?: number;
    days?: number;
}): Milliseconds {
    return MillisecondsSchema.parse(
        milliseconds
        + secondsToMilliseconds(seconds)
        + minutesToMilliseconds(minutes)
        + hoursToMilliseconds(hours)
        + hoursToMilliseconds(days) * 24,
    );
}

/**
 * @description That function modify object image
 */
export const processAndSendImage = async (image: imageType | null, uploadImage: UseMutateAsyncFunction<undefined | {pagination?: {limit: number; offset: number; total: number} | undefined; body: {fileId: string}; statusCode: 200}, unknown, FormData, unknown>) => {
    if (image === null || image.binary === undefined) return;
    const formData = new FormData();
    formData.append('restaurantImage', image.binary, image.name);
    const result = await uploadImage(formData);
    if (result === undefined) {
        return;
    }
    image.id = result.body.fileId;
    image.binary = undefined;
};

export const isAllowedExternalId = (deliveryTypeDrivers: (APIv1RestaurantAdmin['GET']['/pos-drivers']['result']['result']['byCustomerDriver'] | null)[]): boolean => deliveryTypeDrivers.some((driver) => driver !== null && driver.orderableDriver === AllAvailableDrivers.HARSYS);

export const getUrlForRestaurantMenu = (restaurantId: Uuid) => {
    if (process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL === undefined) throw new Error('process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL is undefined. It must be defined.');
    return process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL.replace('{restaurant-id}', restaurantId).replace('{menu}', 'menu');
};

export const getUrlForRestaurantDailyMenu = (restaurantId: Uuid) => {
    if (process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL === undefined) throw new Error('process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL is undefined. It must be defined.');
    return process.env.NEXT_PUBLIC_RESTAURANTS_WEBSITE_URL.replace('{restaurant-id}', restaurantId).replace('{menu}', 'daily-menu');
};

export const getUrlWithParamsAndQueries = (path: string, { params, query }: { params?: Record<string, string> | undefined; query?: Record<string, string> | undefined } = {}) => {
    let resolvedPath: string = path + '?';
    for (const [ key, value ] of Object.entries(params ?? {})) {
        resolvedPath = resolvedPath.replace(':' + key, `${value}`);
    }
    const searchQuery = new URLSearchParams();
    for (const [ key, value ] of Object.entries(query ?? {})) {
        searchQuery.append(key, value);
    }
    return resolvedPath + searchQuery.toString();
};
